import Form from './Form';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-default-export
export default Form;
